import type { SetValueConfig } from "react-hook-form";

import { env } from "./env";

export const SALE_API_URL = env.SALES_URL;

// * it should be followed by MIME type
// * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const MIME_TYPES: Record<string, string> = {
    pdf: "application/pdf",
    txt: "text/plain",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    mp3: "audio/mpeg",
    mpeg: "video/mpeg",
    mp4: "video/mp4",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    wav: "audio/wav",
    jpg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    webm: "video/webm",
};
export const FORM_STATE_OPTIONS: SetValueConfig = {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true,
};
